import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export interface ApiErrorContextProps {
  error: string | null;
  setError: (msg: string) => void;
  clearError: () => void;
}

const ApiErrorContext = createContext<ApiErrorContextProps | undefined>(undefined);

export let dispatchGlobalError: (msg: string) => void = () => {};

export const ApiErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<string | null>(null);

  const clearError = () => setError(null);

  useEffect(() => {
    dispatchGlobalError = setError;
  }, []);

  return (
    <ApiErrorContext.Provider value={{ error, setError, clearError }}>
      {children}
    </ApiErrorContext.Provider>
  );
};

export const useApiError = () => {
  const context = useContext(ApiErrorContext);
  if (!context) {
    throw new Error('useApiError must be used within ApiErrorProvider');
  }
  return context;
};
